import type { Publication } from '~/interfaces/publication';

const getSameAsArray = (publication: Publication): any => {
  const sameAsArray = [
    publication.facebook_url,
    publication.twitter_url,
    publication.instagram_url,
    publication.linkedin_url,
    publication.tiktok_url,
    publication.discord_url,
    publication.threads_url,
  ];

  return sameAsArray.filter((url) => Boolean(url));
};

export default getSameAsArray;
